import { useEffect, useState } from "react";
import { Table, Badge } from "antd";
import { apiRequest } from "@vojomo-core/shared";
import type { ColumnsType } from "antd/es/table";

interface CompanyUser {
  _id: string;
  name: string;
  email: string;
  is_company_admin: boolean;
}

const columns: ColumnsType<CompanyUser> = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name)
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    sorter: (a, b) => a.email.localeCompare(b.email)
  },
  {
    title: "Role",
    dataIndex: "is_company_admin",
    key: "is_company_admin",
    render: (isAdmin: boolean) =>
      isAdmin ? (
        <Badge color="purple" text="Company Admin" />
      ) : (
        <Badge color="default" text="Member" />
      )
  }
];

export function CompanyUsers(): React.ReactElement {
  const [users, setUsers] = useState<CompanyUser[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    apiRequest<CompanyUser[]>({
      subRoute: "company_admin",
      path: "/users"
    })
      .then(setUsers)
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Table
      rowKey="_id"
      loading={isLoading}
      columns={columns}
      dataSource={users}
      pagination={{ pageSize: 20 }}
    />
  );
}
